import React, { useEffect } from "react";
import Table from "../Table";

import { useLocation } from "react-router-dom";

export default function FdAxis(props) {


  const location = useLocation();

  useEffect(()=>{
console.log(props.location?.state)
console.log(location?.state)
  },[])

    const bankInterestRates = [
        {
          MaturityPeriod: "Seven to 14 days",
          PublicInterestRate: "3.00% p.a.",
          SeniorCitizen: "3.50% p.a."
        },
        {
          MaturityPeriod: "15 – 29 days",
          PublicInterestRate: "3.00% p.a.",
          SeniorCitizen: "3.50% p.a."
        },
        {
          MaturityPeriod: "30 – 45 days",
          PublicInterestRate: "3.50% p.a.",
          SeniorCitizen: "4.00% p.a."
        },
        {
          MaturityPeriod: "46 – 60 days",
          PublicInterestRate: "4.25% p.a.",
          SeniorCitizen: "4.75% p.a."
        },
        {
          MaturityPeriod: "61 days less than three months",
          PublicInterestRate: "4.50% p.a.",
          SeniorCitizen: "5.00% p.a."
        },
        {
          MaturityPeriod: "Three months to three months twenty-four days",
          PublicInterestRate: "4.75% p.a.",
          SeniorCitizen: "5.25% p.a."
        },
        {
          MaturityPeriod: "Three months twenty-five days to less than four months",
          PublicInterestRate: "4.75% p.a.",
          SeniorCitizen: "5.25% p.a."
        },
        {
          MaturityPeriod: "Four months less than five months",
          PublicInterestRate: "4.75% p.a.",
          SeniorCitizen: "5.25% p.a."
        },
        {
          MaturityPeriod: "Five months less than six months",
          PublicInterestRate: "4.75% p.a.",
          SeniorCitizen: "5.25% p.a."
        },
        {
          MaturityPeriod: "Six months less than seven months",
          PublicInterestRate: "5.75% p.a.",
          SeniorCitizen: "6.25% p.a."
        },
        {
          MaturityPeriod: "Seven months less than eight months",
          PublicInterestRate: "5.75% p.a.",
          SeniorCitizen: "6.25% p.a."
        },
        {
          MaturityPeriod: "Eight months less than nine months",
          PublicInterestRate: "5.75% p.a.",
          SeniorCitizen: "6.25% p.a."
        },
        {
          MaturityPeriod: "Nine months less than ten months",
          PublicInterestRate: "6.00% p.a.",
          SeniorCitizen: "6.50% p.a."
        },
        {
          MaturityPeriod: "Ten months less than eleven months",
          PublicInterestRate: "6.00% p.a.",
          SeniorCitizen: "6.50% p.a."
        },
        {
          MaturityPeriod: "Eleven months to eleven months 24 days",
          PublicInterestRate: "6.00% p.a.",
          SeniorCitizen: "6.50% p.a."
        },
        {
          MaturityPeriod: "Eleven months 25 days less than one year",
          PublicInterestRate: "6.00% p.a.",
          SeniorCitizen: "6.50% p.a."
        },
        {
          MaturityPeriod: "One year to one year four days",
          PublicInterestRate: "6.70% p.a.",
          SeniorCitizen: "7.20% p.a."
        },
        {
          MaturityPeriod: "One year five days to one year ten days",
          PublicInterestRate: "6.70% p.a.",
          SeniorCitizen: "7.20% p.a."
        },
        {
          MaturityPeriod: "One year 11 days to one year 24 days",
          PublicInterestRate: "6.70% p.a.",
          SeniorCitizen: "7.20% p.a."
        },
        {
          MaturityPeriod: "One year 25 days to less than 13 months",
          PublicInterestRate: "6.70% p.a.",
          SeniorCitizen: "7.20% p.a."
        },
        {
          MaturityPeriod: "13 months to less than 14 months",
          PublicInterestRate: "6.70% p.a.",
          SeniorCitizen: "7.20% p.a."
        },
        {
          MaturityPeriod: "14 months to less than 15 months",
          PublicInterestRate: "6.70% p.a.",
          SeniorCitizen: "7.20% p.a."
        },
        {
          MaturityPeriod: "15 months to less than 16 months",
          PublicInterestRate: "7.10% p.a.",
          SeniorCitizen: "7.60% p.a."
        },
        {
          MaturityPeriod: "16 months to less than 17 months",
          PublicInterestRate: "7.10% p.a.",
          SeniorCitizen: "7.60% p.a."
        },
        {
          MaturityPeriod: "17 months to less than 18 months",
          PublicInterestRate: "7.20% p.a.",
          SeniorCitizen: "7.85% p.a."
        },
        {
          MaturityPeriod: "18 Months to less than two years",
          PublicInterestRate: "7.10% p.a.",
          SeniorCitizen: "7.60% p.a."
        },
        {
          MaturityPeriod: "Two years to less than 30 months",
          PublicInterestRate: "7.10% p.a.",
          SeniorCitizen: "7.60% p.a."
        },
        {
          MaturityPeriod: "30 months to less than three years",
          PublicInterestRate: "7.10% p.a.",
          SeniorCitizen: "7.60% p.a."
        },
        {
          MaturityPeriod: "Three years to less than five years",
          PublicInterestRate: "7.10% p.a.",
          SeniorCitizen: "7.60% p.a."
        },
        {
          MaturityPeriod: "Five years to ten years",
          PublicInterestRate: "7.00% p.a.",
          SeniorCitizen: "7.75% p.a."
        }
      ];
      const interestRates = [
        {
          MaturityPeriod: "Seven to 14 days",
          PublicInterestRate: "4.80% p.a.",
          SeniorCitizen: "5.30% p.a."
        },
        {
          MaturityPeriod: "15 – 29 days",
          PublicInterestRate: "5.00% p.a.",
          SeniorCitizen: "5.50% p.a."
        },
        {
          MaturityPeriod: "30 – 45 days",
          PublicInterestRate: "5.50% p.a.",
          SeniorCitizen: "6.00% p.a."
        },
        {
          MaturityPeriod: "46 – 60 days",
          PublicInterestRate: "5.75% p.a.",
          SeniorCitizen: "6.25% p.a."
        },
        {
          MaturityPeriod: "61 days less than three months",
          PublicInterestRate: "6.00% p.a.",
          SeniorCitizen: "6.50% p.a."
        },
        {
          MaturityPeriod: "Three months to three months twenty-four days",
          PublicInterestRate: "6.50% p.a.",
          SeniorCitizen: "7.00% p.a."
        },
        {
          MaturityPeriod: "Three months twenty-five days to less than four months",
          PublicInterestRate: "5.00% p.a.",
          SeniorCitizen: "5.50% p.a."
        },
        {
          MaturityPeriod: "Four months less than five months",
          PublicInterestRate: "6.50% p.a.",
          SeniorCitizen: "7.00% p.a."
        },
        {
          MaturityPeriod: "Five months less than six months",
          PublicInterestRate: "6.50% p.a.",
          SeniorCitizen: "7.00% p.a."
        },
        {
          MaturityPeriod: "Six months less than seven months",
          PublicInterestRate: "6.75% p.a.",
          SeniorCitizen: "7.25% p.a."
        },
        {
          MaturityPeriod: "Seven months less than eight months",
          PublicInterestRate: "6.75% p.a.",
          SeniorCitizen: "7.25% p.a."
        },
        {
          MaturityPeriod: "Eight months less than nine months",
          PublicInterestRate: "6.75% p.a.",
          SeniorCitizen: "7.25% p.a."
        },
        {
          MaturityPeriod: "Nine months less than ten months",
          PublicInterestRate: "6.85% p.a.",
          SeniorCitizen: "7.35% p.a."
        },
        {
          MaturityPeriod: "Ten months less than eleven months",
          PublicInterestRate: "6.85% p.a.",
          SeniorCitizen: "7.35% p.a."
        },
        {
          MaturityPeriod: "Eleven months to eleven months 24 days",
          PublicInterestRate: "6.85% p.a.",
          SeniorCitizen: "7.35% p.a."
        },
        {
          MaturityPeriod: "Eleven months 25 days less than one year",
          PublicInterestRate: "5.00% p.a.",
          SeniorCitizen: "5.50% p.a."
        },
        {
          MaturityPeriod: "One year to one year four days",
          PublicInterestRate: "7.40% p.a.",
          SeniorCitizen: "7.75% p.a."
        },
        {
          MaturityPeriod: "One year five days to one year ten days",
          PublicInterestRate: "7.40% p.a.",
          SeniorCitizen: "7.75% p.a."
        },
        {
          MaturityPeriod: "One year 11 days to one year 24 days",
          PublicInterestRate: "7.30% p.a.",
          SeniorCitizen: "7.75% p.a."
        },
        {
          MaturityPeriod: "One year 25 days to less than 13 months",
          PublicInterestRate: "7.30% p.a.",
          SeniorCitizen: "7.75% p.a."
        },
        {
          MaturityPeriod: "13 months to less than 14 months",
          PublicInterestRate: "7.30% p.a.",
          SeniorCitizen: "7.75% p.a."
        },
        {
          MaturityPeriod: "14 months to less than 15 months",
          PublicInterestRate: "7.30% p.a.",
          SeniorCitizen: "7.75% p.a."
        },
        {
          MaturityPeriod: "15 months to less than 16 months",
          PublicInterestRate: "7.05% p.a.",
          SeniorCitizen: "7.55% p.a."
        },
        {
          MaturityPeriod: "16 months to less than 17 months",
          PublicInterestRate: "7.05% p.a.",
          SeniorCitizen: "7.55% p.a."
        },
        {
          MaturityPeriod: "17 months to less than 18 months",
          PublicInterestRate: "7.05% p.a.",
          SeniorCitizen: "7.70% p.a."
        },
        {
          MaturityPeriod: "18 Months to less than two years",
          PublicInterestRate: "7.05% p.a.",
          SeniorCitizen: "7.55% p.a."
        },
        {
          MaturityPeriod: "Two years to less than 30 months",
          PublicInterestRate: "7.00% p.a.",
          SeniorCitizen: "7.50% p.a."
        },
        {
          MaturityPeriod: "30 months to less than three years",
          PublicInterestRate: "7.00% p.a.",
          SeniorCitizen: "7.50% p.a."
        },
        {
          MaturityPeriod: "Three years to less than five years",
          PublicInterestRate: "7.00% p.a.",
          SeniorCitizen: "7.50% p.a."
        },
        {
          MaturityPeriod: "Five years to ten years",
          PublicInterestRate: "7.00% p.a.",
          SeniorCitizen: "7.75% p.a."
        }
      ];
      const tenureInterestRates = [
        {
          Tenure: "One year to One year four days",
          InterestRate: "6.70% p.a."
        },
        {
          Tenure: "One year 5 days to One year 10 days",
          InterestRate: "6.70% p.a."
        },
        {
          Tenure: "One year 11 days to One year 24 days",
          InterestRate: "6.70% p.a."
        },
        {
          Tenure: "One year 25 days to less than 13 months",
          InterestRate: "6.70% p.a."
        },
        {
          Tenure: "13 months to less than 14 months",
          InterestRate: "6.70% p.a."
        },
        {
          Tenure: "14 to less than 15 months",
          InterestRate: "6.70% p.a."
        },
        {
          Tenure: "15 months to less than 16 months",
          InterestRate: "7.10% p.a."
        },
        {
          Tenure: "16 months to less than 17 months",
          InterestRate: "7.10% p.a."
        },
        {
          Tenure: "17 Months to less than 18 months",
          InterestRate: "7.20% p.a."
        },
        {
          Tenure: "18 months to less than two years",
          InterestRate: "7.10% p.a."
        },
        {
          Tenure: "Two years to less than 30 months",
          InterestRate: "7.10% p.a."
        },
        {
          Tenure: "30 months to less than three years",
          InterestRate: "7.10% p.a."
        },
        {
          Tenure: "Three years to less than five years",
          InterestRate: "7.10% p.a."
        },
        {
          Tenure: "Five years to ten years",
          InterestRate: "7.00% p.a."
        }
      ];
      
      
      
    
      const currencyInterestRates = [
        {
          Tenure: "1 year to less than 2 years",
          CAD: "4.65",
          AUD: "4.40",
          EURO: "3.35",
          GBP: "5.00",
          USD: "5.35"
        },
        {
          Tenure: "2 years to less than 3 years",
          CAD: "3.30",
          AUD: "3.75",
          EURO: "0.01",
          GBP: "4.00",
          USD: "3.95"
        },
        {
          Tenure: "3 years to less than 4 years",
          CAD: "2.90",
          AUD: "3.60",
          EURO: "0.01",
          GBP: "0.01",
          USD: "3.65"
        },
        {
          Tenure: "4 years to less than 5 years",
          CAD: "2.70",
          AUD: "3.55",
          EURO: "0.01",
          GBP: "0.01",
          USD: "3.30"
        },
        {
          Tenure: "5 years",
          CAD: "2.70",
          AUD: "3.55",
          EURO: "0.01",
          GBP: "0.01",
          USD: "3.30"
        }
      ];
      
      
      
      
  return (
    <>
    <section
        className="services-area bg-white pt-110  wow fadeInUp"
        style={{ display: "flex", flexDirection: "row" }}
      >
      <div
        className="container "
       
      
      >
        <div className="section-title mb-45">
  <h1 className="ui header">Axis Bank FD Rates 2024</h1>
  <p>Axis Bank offers the <a href="/fixed-deposit-rate.html" target="_blank">Fixed Deposit (FD)</a> account at attractive interest rates ranging between <strong>3.00% p.a. and 7.10% p.a</strong>. for general citizens and <strong>3.50% to 7.75% p.a. </strong>for senior citizens for deposits below Rs.2 crore. The tenure offered by the bank ranges from seven days to ten years.</p>
</div>

        <div className="section-title mb-45">
          <span className="short-title-2">_Fixed Deposit </span>
            
          <div className="table-responsive">
            <table className="table table-borderless mb-0">
              <thead>
                <tr style={{ backgroundColor: "whitesmoke" }}>
                  <th className="feature-head " scope="col">
                    Bank
                  </th>
                  <th className="text-center" scope="col">
                    <h5 style={{ fontSize: "80%" }}>
                      General Public Interest Rates p.a.
                    </h5>
                  </th>
                  <th className="text-center" scope="col">
                    <h5 style={{ fontSize: "80%" }}>
                      Senior Citizen Interest Rates p.a.
                    </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                {bankInterestRates.map((item, index) => (
                  <tr>
                   <th
                      className="feature-head"
                      scope="col"
                      style={{ fontWeight: "normal",lineHeight:"100%"}}
                      key={index}
                    >
                      {item.MaturityPeriod}
                     
                    </th>
                    <td
                      className="feature-item"
                      style={{ fontWeight: "normal" }}
                      key={index}
                    >
                      {item.PublicInterestRate}
                    </td>
                    <td
                      className="feature-item"
                      style={{ fontWeight: "normal" }}
                    >
                      {item.SeniorCitizen}
                    </td>
                  </tr>
                ))}
                
              </tbody>
            </table>
          </div>
        </div>

        <p><strong>Note: </strong>The interest rates mentioned in the table are effective from <strong>6 March 2024</strong><strong>.&nbsp;</strong>&nbsp;</p>
    
        <h2 id="domestic_rates__2" className="ui header mb-20 mt-30">Domestic Rates for Deposits Above Rs.2 crore to Less than Rs.5 crore</h2>
        <div className="section-title mb-45">
          <span className="short-title-2">_Fixed Deposit </span>
            
          <div className="table-responsive">
            <table className="table table-borderless mb-0">
              <thead>
                <tr style={{ backgroundColor: "whitesmoke" }}>
                  <th className="feature-head " scope="col">
                    Bank
                  </th>
                  <th className="text-center" scope="col">
                    <h5 style={{ fontSize: "80%" }}>
                      General Public Interest Rates p.a.
                    </h5>
                  </th>
                  <th className="text-center" scope="col">
                    <h5 style={{ fontSize: "80%" }}>
                      Senior Citizen Interest Rates p.a.
                    </h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                {interestRates.map((item, index) => (
                  <tr>
                   <th
                      className="feature-head"
                      scope="col"
                      style={{ fontWeight: "normal",lineHeight:"100%"}}
                      key={index}
                    >
                      {item.MaturityPeriod}
                     
                    </th>
                    <td
                      className="feature-item"
                      style={{ fontWeight: "normal" }}
                      key={index}
                    >
                      {item.PublicInterestRate}
                    </td>
                    <td
                      className="feature-item"
                      style={{ fontWeight: "normal" }}
                    >
                      {item.SeniorCitizen}
                    </td>
                  </tr>
                ))}
                
              </tbody>
            </table>
          </div>
        </div>

        <div className="section-title mb-45">
  <h1 className="ui header">Axis Bank Tax Saving FD Interest Rates  </h1>
  <p>Axis Bank offers the Tax Saving FD at an attractive interest rate and a tenure of five years. The minimum and maximum amounts that can be deposited are Rs.100 and Rs.1.5 lakh, respectively. Currently, the bank offers an interest rate of 7.00% p.a.
<h3>Axis Bank NRE FD Rates (Less the Rs.2 crore) 
</h3>
</p>
</div>
        <div className="section-title mb-45">
            
          <div className="table-responsive">
            <table className="table table-borderless mb-0">
              <thead>
                <tr style={{ backgroundColor: "whitesmoke" }}>
                  <th className="feature-head " scope="col">Tenure
                  </th>
                  <th className="text-center" scope="col">
                    <h5 style={{ fontSize: "80%" }}>
                      Interest Rates p.a.
                    </h5>
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                {tenureInterestRates.map((item, index) => (
                  <tr>
                   <th
                      className="feature-head"
                      scope="col"
                      style={{ fontWeight: "normal",lineHeight:"100%"}}
                      key={index}
                    >
                      {item.Tenure}
                     
                    </th>
                    <td
                      className="feature-item"
                      style={{ fontWeight: "normal" }}
                      key={index}
                    >
                      {item.InterestRate}
                    </td>
                   
                  </tr>
                ))}
                
              </tbody>
            </table>
          </div>
        </div>



        <div className="section-title mb-45">
  <h1 className="ui header">Axis Bank FCNR FD Rates  </h1>
  

</div>

        <div className="section-title mb-45">
            
            <div className="table-responsive">
              <table className="table table-borderless mb-0">
                <thead>
                  <tr style={{ backgroundColor: "whitesmoke" }}>
                    <th className="feature-head " scope="col">Tenure
                    </th>
                    <th className="text-center" scope="col">
                      <h5 style={{ fontSize: "80%" }}>
                       CAD
                      </h5>
                      
                    </th>
                    <th className="text-center" scope="col">
                      <h5 style={{ fontSize: "80%" }}>
                        AUD
                      </h5>
                      
                    </th>
                    <th className="text-center" scope="col">
                      <h5 style={{ fontSize: "80%" }}>
                        EURO
                      </h5>
                      
                    </th>
                    <th className="text-center" scope="col">
                      <h5 style={{ fontSize: "80%" }}>
                       GBP
                      </h5>
                      
                    </th>
                    <th className="text-center" scope="col">
                      <h5 style={{ fontSize: "80%" }}>
USD                      
</h5>
                      
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  {currencyInterestRates.map((item, index) => (
                    <tr>
                     <th
                        className="feature-head"
                        scope="col"
                        style={{ fontWeight: "normal",lineHeight:"100%"}}
                        key={index}
                      >
                        {item.Tenure}
                       
                      </th>
                      
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal",maxWidth:"12%" }}
                        key={index}
                      >
                        {item.CAD}
                      </td>
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal",maxWidth:"12%"  }}
                        key={index}
                      >
                        {item.AUD}
                      </td>
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal",maxWidth:"12%"  }}
                        key={index}
                      >
                        {item.EURO}
                      </td>
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal",maxWidth:"12%"  }}
                        key={index}
                      >
                        {item.GBP}
                      </td>
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal",maxWidth:"12%"  }}
                        key={index}
                      >
                        {item.USD}
                      </td>
                     
                    </tr>
                  ))}
                  
                </tbody>
              </table>
            </div>
          </div>
          <p className="mb-45"><strong>Note:</strong>&nbsp;The interest rates mentioned in the table are effective from <strong>29 February 2024.</strong></p>
          <h2 id="features_and_be_6" className="ui header mb-20">Features and Benefits of Axis Bank Fixed Deposits</h2>
    
          <ul role="list" className="ui list mb-30" style={{display:"flex",flexDirection:"column",gap:"10px"}}> 
  <li role="listitem" className="" style={{listStyleType:"disc"}}>
    FDs are offered at attractive interest rates.
  </li>
  <li role="listitem" className="" style={{listStyleType:"disc"}}>
    In case you open the FD via the mobile app or internet banking, Rs.5,000
    must be the initial deposit.
  </li>
  <li role="listitem" className="" style={{listStyleType:"disc"}}>
    In case you open the FD by visiting the bank, Rs.10,000 must be the initial
    deposit.
  </li>
  <li role="listitem" className="" style={{listStyleType:"disc"}}>
    The process to open an FD account is easy and can be completed online.
  </li>
  <li role="listitem" className="" style={{listStyleType:"disc"}}>
    The tenure of the FD ranges between seven days and ten years.
  </li>
</ul>
<h2 id="eligibility_cri_7" className="ui header">Eligibility Criteria</h2>
<p className="mb-10">The below-mentioned entities and individuals can open an FD account:</p>

<ul role="list" className="ui list" >
  <li role="listitem" className="">
    Trust Accounts
  </li>
  <li role="listitem" className="">
    Limited Companies
  </li>
  <li role="listitem" className="">
    Partnership Firms
  </li>
  <li role="listitem" className="">
    Sole Proprietorship Firms
  </li>
  <li role="listitem" className="">
    Hindu Undivided Families
  </li>
  <li role="listitem" className="">
    Residents
  </li>
</ul>
<h2 id="documents_requi_8" className="ui header">Documents Required for Axis Bank Fixed Deposits</h2>
<p className="mb-10">The list of documents that must be submitted to open an FD account are mentioned below:</p>
<ul role="list" className="ui list">
  <li role="listitem" className="">
    <strong>Partnership Firms</strong>
    <ul role="list" className="ui list mt-2">
      <li role="listitem" className="">
        Photographs of the individuals who operate the account
      </li>
      <li role="listitem" className="">
        Letter from the partners stating that the individual can open the
        account
      </li>
      <li role="listitem" className="">
        Partnership deed
      </li>
    </ul>
  </li>
  <li role="listitem" className="">
    <strong>Clubs/ Associations</strong>
    <ul role="list" className="ui list mt-2">
      <li role="listitem" className="">
        Photographs of the individuals who operate the account
      </li>
      <li role="listitem" className="">
        The board must provide a Copy of the Resolution giving permission to the
        members to operate the account
      </li>
      <li role="listitem" className="">
        Association Bye-Laws
      </li>
    </ul>
  </li>
  <li role="listitem" className="">
    <strong>Trusts</strong>
    <ul role="list" className="ui list mt-2 ">
      <li role="listitem" className="">
        Photographs of the individuals who operate the account
      </li>
      <li role="listitem" className="">
        Registration Certificate
      </li>
      <li role="listitem" className="">
        The trustees must provide a Copy of the Resolution giving permission to
        the members to operate the account
      </li>
      <li role="listitem" className="">
        Trust deed
      </li>
    </ul>
  </li>
  <li role="listitem" className="">
    <strong>Sole Proprietorships/ Hindu Undivided Families/ Individuals</strong>
    <ul role="list" className="ui list mt-2">
      <li role="listitem" className="">
        Photograph
      </li>
      <li role="listitem" className="">
        Valid driving license or
        <a href="/passport.html" target="_blank">
          {" "}
          passport
        </a>
      </li>
      <li role="listitem" className="">
        Account holder's introduction for the last six months
      </li>
    </ul>
  </li>
</ul>

<h2 className="ui header">FAQs on Axis Bank FD Rates</h2>
<ol className="clearfix" style={{display:"flex",flexDirection:"column",gap:"16px"}}>
  <li className="mb-lg" style={{listStyleType:"number"}}>
    <strong>
      What is the highest interest rate offered by the bank for deposits less
      than Rs. 2 crore?
    </strong>{" "}
    <p>
      For deposits less than Rs.2 crore, the highest interest rate that is
      offered is <strong>7.20 % p.a.</strong> for a tenure ranging seventeen
      months to less than eighteen months..
    </p>
  </li>
  <li className="mb-lg" style={{listStyleType:"number"}}>
    <strong>Are additional interest rates offered to senior citizens?</strong>{" "}
    <p>Yes, Axis Bank offers additional interest rates for senior citizens.</p>
  </li>
  <li className="mb-lg" style={{listStyleType:"number"}}>
    <strong>Is the auto-renewal facility provided by Axis Bank?</strong>{" "}
    <p>Yes, the auto-renewal facility is offered by Axis Bank.</p>
  </li>
  <li className="mb-lg" style={{listStyleType:"number"}}>
    <strong>Does Axis Bank offer the premature withdrawal facility?</strong>{" "}
    <p>
      Yes, Axis Bank offers the premature withdrawal facility. Depending on when
      the money is withdrawn, the penalty that will be levied will vary.
    </p>
  </li>
  <li className="mb-lg" style={{listStyleType:"number"}}>
    <strong>Is TDS applicable on an FD account?</strong>{" "}
    <p>Yes, TDS is applicable.</p>
  </li>
</ol>

      </div>
      </section> 
      {/* <Table list1={ interestRates}/> */}
      

      </>
  );
}
